/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReferralCodeValidationResultMetadata } from './ReferralCodeValidationResultMetadata';
import {
    ReferralCodeValidationResultMetadataFromJSON,
    ReferralCodeValidationResultMetadataFromJSONTyped,
    ReferralCodeValidationResultMetadataToJSON,
} from './ReferralCodeValidationResultMetadata';

/**
 * 
 * @export
 * @interface ReferralCodeValidationResult
 */
export interface ReferralCodeValidationResult {
    /**
     * 
     * @type {boolean}
     * @memberof ReferralCodeValidationResult
     */
    code_valid: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeValidationResult
     */
    error_message: string;
    /**
     * 
     * @type {ReferralCodeValidationResultMetadata}
     * @memberof ReferralCodeValidationResult
     */
    metadata: ReferralCodeValidationResultMetadata | null;
}

/**
 * Check if a given object implements the ReferralCodeValidationResult interface.
 */
export function instanceOfReferralCodeValidationResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code_valid" in value;
    isInstance = isInstance && "error_message" in value;
    isInstance = isInstance && "metadata" in value;

    return isInstance;
}

export function ReferralCodeValidationResultFromJSON(json: any): ReferralCodeValidationResult {
    return ReferralCodeValidationResultFromJSONTyped(json, false);
}

export function ReferralCodeValidationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralCodeValidationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code_valid': json['code_valid'],
        'error_message': json['error_message'],
        'metadata': ReferralCodeValidationResultMetadataFromJSON(json['metadata']),
    };
}

export function ReferralCodeValidationResultToJSON(value?: ReferralCodeValidationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code_valid': value.code_valid,
        'error_message': value.error_message,
        'metadata': ReferralCodeValidationResultMetadataToJSON(value.metadata),
    };
}

